import React from 'react'
// import Icon from '@ant-design/icons'
// import { ReactComponent as IconNoDataSVG } from '../assets/svg/ic_asse_add_b.svg'
import nondata_large from '../assets/images/nondata_large.png'

export const EmptyImage = <img src={nondata_large} style={{ width: 100 }} alt='nodata' />

const CustomizeRenderEmpty = () => {
    return (
        <div style={{ textAlign: 'center', color: 'rgba(0, 0, 0, 0.25)' }}>
            {EmptyImage}
            <p>ไม่มีข้อมูล</p>
        </div>
    )
}

export default CustomizeRenderEmpty
